module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/black-0.8-2c4e463fd176279a5cb5b08eb1a6f63d.png";